/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CommitResultStatus {
  ValidationErrors = 'ValidationErrors',
  PendingPayment = 'PendingPayment',
  ReservationCommitted = 'ReservationCommitted',
  CommitInProgress = 'CommitInProgress'
}
